'use strict';
(function ($) {
	$.widget('Vetology.ViewLogs', {
		"options": {
			table: null,
			logTables: {}
		},

		_init: function () {
			const o = this;

			o.options.table = $("#log-viewer-table").DataTable({
				columns: [
					{
						orderable: false
					},
					{
						orderable: true
					},
					{
						orderable: false
					},
					{
						orderable: true
					},
					{
						orderable: false
					}
				],
				// 'responsive': true,
				'order': [[1, 'asc']],
				'autowidth': false,
				'dom': 'ltr',
				'paging': false
			});

			o._createColumnFilters();

			o._addEventListeners();
		},

		_createColumnFilters: function() {
			const o = this;

		//	o._createColumnInputFilter('#log-viewer-table', 'thead .last-log-line-col', 'Search phrase');
		},

		_createColumnInputFilter: function($table, cls, placeholder) {
			let $th = $(cls, $table);
			let $input = $("<input type='text' placeholder='" + placeholder + "'/>");
			$th.append($input);
		},

		_addEventListeners: function() {
			const o = this;

			this._on(this.element, {
				'click .expand-log': o._expandRowLog,
				'click .expand-trace': o._expandRowTrace
			});

			$("#log-viewer-table").on('keyup change', '.log-table thead th input', function(e) {
				let colNum = $(e.currentTarget).parent().index();
				const $tr = $(e.currentTarget).parents('tr').eq(1).prev('tr');
				const table = o.options.logTables[$tr.attr('id')];
				if (typeof table != 'undefined') {
					table.column(3).search(e.currentTarget.value).draw();
				}
			});

            $('.test-log-btn').on('click', function(e) {
                o._addTestLogEntry(e);
            })
		},

        _addTestLogEntry: function(event) {
            const o = this;
            const ip = event.currentTarget.dataset.ip;
            const data = new URLSearchParams({
                ip: ip
            });
            fetch('/admin/log-viewer/add-test-log-entry?' + data.toString(), {
                headers: {
                    'Content-Type': 'application/json',
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json",
                }
            }).then(response => {
                if (!response.ok) {
                    toastr.error('A log entry could not be created');
                } else {
                    response.json().then(data => {
                        if (data.success) {
                            toastr.success('A log entry has successfully been created', null, {
                                onHidden: function() {
                                    toastr.info('Refreshing page');
                                    window.location.reload();
                                }
                            });
                        } else {
                            toastr.error(data.message);
                        }
                    });
                }
            });
         },

		_expandRowLog: function(event) {
			const o = this;
			const $tr = $(event.currentTarget).closest('tr');
			const row = o.options.table.row($tr);
			const logID = $tr.attr('id');

			if (row.child.isShown()) {
				row.child.hide();
				$tr.removeClass('shown');
				delete o.options.logTables[logID];

			} else {
				const log = $tr.data('log');
				row.child(o._formatChildRow(row.data(), log)).show();
				const $logTable = $('table', row.child());
				o.options.logTables[logID] = $logTable.DataTable({
					columns: [
						{
							orderable: false
						},
						{
							orderable: true
						},
						{
							orderable: true
						},
						{
							orderable: false
						}
					],
					info: false,
					paging: false,
					order:  [[1, 'asc']],
					dom: 'ltr'
				});
				$tr.addClass('shown');
			}
		},

		_expandRowTrace: function(event) {
			const o = this;
			const $tr = $(event.currentTarget).closest('tr');
			const $parentTR = $tr.parents('tr').prev('tr');
			const row = o.options.logTables[$parentTR.attr('id')].row($tr);
			const logID = $tr.attr('id');

			if (row.child.isShown()) {
				row.child.hide();
				$tr.removeClass('shown');
			} else {
				const trace = $tr.data('trace');
				if (typeof trace != "undefined") {
					row.child(o._formatChildTraceRow(row.data(), trace)).show();
				}

				$tr.addClass('shown');
			}
		},

		_formatChildRow: function(data, log) {
			const $logTable = $('table', "#log-table-container").clone();
			const $tbody = $("tbody", $logTable);
			$.each(log, function(idx, row) {
				const hasTrace = (row[2] !== 'undefined');
				const $tr = $("<tr id='" + data.DT_RowId + '_' + idx + "'/>");
				$tr.append($("<td><a class='expand-trace' href='javascript:void(0)'>" + (hasTrace ? "<span class='vetology-plus'></span>" : "") + "</a></td>"));
				$tr.append($("<td class='log-time-col'>" + row[0] + "</td>"));
				$tr.append($("<td class='ip-col'>" + row[3] + "</td>"));
				$tr.append($("<td class='log-message-col'>" + row[1] + "</td>"));
				$tbody.append($tr);
				if (hasTrace) {
					$tr.data('trace', row[2]);
				}
			});

			return $logTable.get();
		},

		_formatChildTraceRow: function(data, trace) {
			return "<div class='stack-trace'>" + trace.replace(/\n/g, "<br/>") + "</div>";
		}

	});
})(jQuery);
